import {PRESCRIPTION_LOCATION, SMART_SEARCH_FILLING_METHOD} from '../types/successPage';

export const PRODUCT_TYPES = {
    ACCESSORY: 'accessories',
    CONTACT_LENSES: 'contact_lenses',
    EYE_EXAM: 'eye_exam',
    EYEGLASSES: 'eyeglasses',
    GIFT: 'gift',
    SUNGLASSES: 'sunglasses',
    UPGRADE: 'upgrade',
} as const;

export const DOCTOR_DETAILS_DEFAULT = {
    city: '',
    email: '',
    fax: '',
    filling_method: SMART_SEARCH_FILLING_METHOD,
    firstName: '',
    lastName: '',
    location: PRESCRIPTION_LOCATION,
    mailingAddress1stLine: '',
    mailingAddressCity: '',
    mailingAddressFax: '',
    mailingAddressPhone: '',
    mailingAddressState: '',
    mailingAddressZipCode: '',
    name: '',
    organizationName: '',
    patientName: '',
    phone: '',
    regionCode: '',
};

export const TYP_UPSELL_TYPES = {
    ACCESSORY: 'accessory',
};

export const UPSELL_ALIASES = {
    DIGITAL_BLOCK: 'digitalBlock',
    HYDROPHOBIC: 'hydrophobic',
    INSURANCE: 'insurance_20_20-1-year',
    INSURANCE_OLD: 'insurance_20_20',
    INSURANCE_SECOND_YEAR: 'insurance_20_20-2-year',
    UV: 'uv',
};

export const UPSELL_NAMES: {[key: string]: string} = {
    digitalBlock: 'Blue Light',
    hydrophobic: 'Super Hydrophobic',
    'insurance_20_20-1-year': '1-year Coverage',
    'insurance_20_20-2-year': '2-year Coverage',
    uv: 'Premium Lens Coatings',
};

export enum PRESCRIPTION_METHOD {
    FILL_IT_ONLINE_METHOD = 1,
    SEND_EMAIL_OR_FAX_METHOD = 3,
    UPLOAD_METHOD = 4,
    MAGNIFICATION_METHOD = 5,
    BY_SAVED = 9,
}

export const SINGLE_VISION = 'Single-Vision';
export const SINGLE_VISION_USAGE_NAME = 'Distance';
export const NON_PRESCRIPTION = 'Frame';
export const WIZARD_ID_WITH_5_PACKAGES = ['1', '2', '14', '15'];
export const READING = 'Reading';
export const USAGES_WITH_5_PACKAGES = [READING, SINGLE_VISION];

export const TRACKED_DETAILS: {[key: string]: string} = {
    [PRESCRIPTION_METHOD.FILL_IT_ONLINE_METHOD]: 'Dr. Details',
    [PRESCRIPTION_METHOD.SEND_EMAIL_OR_FAX_METHOD]: 'Prescription Image',
};
export const SHOW_WIZARD = 'showWizard';
export const VISTA_LENSES_PER_BOX = 30;

export const UPSELLS_LIST = [
    {
        alias: 'hydrophobic',
        description: 'Easy-to-clean, water-repelleing lenses.',
        popupTitle: 'Super Hydrophobic Coating',
        postScriptum: '',
        title: 'Super Hydrophobic',
    },
    {
        alias: 'insurance_20_20',
        description: 'Protect your glasses. Comprehensive \n1-year warranty.',
        popupTitle: '20/20 Enhanced Coverage',
        postScriptum: '',
        title: '1-Year Coverage',
    },
    {
        alias: 'insurance_20_20-1-year',
        description: 'Protect your glasses. Comprehensive \n1-year warranty',
        popupTitle: '20/20 Enhanced Coverage',
        postScriptum: '',
        title: '1-Year Coverage',
    },
    {
        alias: 'insurance_20_20-2-year',
        description: 'Enjoy a limited-time discount on our \n2-year coverage plan.',
        popupTitle: '20/20 Enhanced Coverage',
        postScriptum: '',
        title: '2-Year Coverage',
    },
    {
        alias: 'digitalBlock',
        description: 'Protect your eyes from blue light.',
        popupTitle: 'Blue Light Lenses',
        postScriptum: '',
        title: 'Blue Light Protection',
    },
    {
        alias: 'uv',
        description: 'UV protective + anti-reflective coatings.',
        popupTitle: '',
        postScriptum: '',
        title: 'Premium Lens Coatings',
    },
];
